import { Box, styled } from '@mui/material';

const MapBlock = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #8080804f;
`;

export default MapBlock;
